import Repository from '../../../Repository';

const resource = '/shopify/discounts/price-rule';

export default {
  discountCodeSearch(region, discountCode, strict = true) {
    return Repository.get(`${resource}/search`, {
      params: {
        region,
        strict,
        'code': discountCode,
      },
    });
  },
};
